import { render, staticRenderFns } from "./DespesaAnexos.vue?vue&type=template&id=9bf101d0"
import script from "./DespesaAnexos.vue?vue&type=script&lang=js"
export * from "./DespesaAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports